/**
 * Created by rickborst on 16/06/2017.
 */

import { AssetTypes } from "models/asset";
import {
  getPromotionPopupConfig,
  getUrlsLocationFromRemoteConfig,
} from "utils/firebase/remoteConfig";
import { getInstance as getStore } from "store/store";
import { setPromotionPopupConfig } from "../../../store/actions/promotionpopupconfig";

/**
 * Converts config properties to read parameters.
 *
 * @returns {Object} Read parameters.
 */
export async function convertForRead() {
  let url = "";
  const store = getStore();

  let unparsedRemoteConfig = await getUrlsLocationFromRemoteConfig();
  const unparsedPromotionPopupConfig = await getPromotionPopupConfig();

  const parsedUrlsLocation = JSON.parse(unparsedRemoteConfig._value);
  const parsedPromotionPopupConfig = JSON.parse(
    unparsedPromotionPopupConfig._value
  );

  store.dispatch(setPromotionPopupConfig(parsedPromotionPopupConfig));
  const locationUrlKey = Object.keys(parsedUrlsLocation).find(
    (urlItem) => urlItem === location.origin
  );

  if (!locationUrlKey) {
    url = parsedUrlsLocation.default;

    return {
      url,
    };
  }

  url = parsedUrlsLocation[locationUrlKey];

  return {
    url,
  };

  // switch (location.origin) {
  //     case 'http://localhost:8080':
  //     case 'http://localhost:8081':
  //     case 'http://dev-5now.lampawork.com':

  //         // url = 'htztp://54.244.95.154/Bentley/Config/kids_stg_rge.json'; // kids staging
  //         url = 'http://dev-5now.lampawork.com/config/bigi/bigi_prod_config.json';
  //         break;

  //     case 'https://www.bigizone.co.il':
  //         url = 'https://www.bigizone.co.il/bigi_prod.json'; // Production
  //         break;

  //     case 'https://34.102.192.87':
  //         url = 'https://34.102.192.87/bigi_pp.json'; // Pre-prod
  //         break;

  //     case 'http://34.102.192.87':
  //         url = 'http://34.102.192.87/bigi_pp.json'; // Pre-prod
  //         break;

  //     case 'https://bigi-pp.sport5tv.co.il':
  //         url = 'https://bigi-pp.sport5tv.co.il/bigi_pp.json'; // Pre-prod
  //         break;

  //     case 'http://bigi-pp.sport5tv.co.il':
  //         url = 'http://bigi-pp.sport5tv.co.il/bigi_pp.json'; // Pre-prod
  //         break;

  //     case 'http://35.186.202.81': // Staging
  //     case 'http://bigi-stg.sport5tv.co.il':
  //         url = 'http://bigi-stg.sport5tv.co.il/bigi_stg.json';
  //         break;

  //     case 'https://35.186.202.81': // Staging
  //     case 'https://bigi-stg.sport5tv.co.il':
  //         url = 'http://bigi-stg.sport5tv.co.il/bigi_stg.json';
  //         break;

  //     // case 'http://35.186.202.81': // Staging
  //     // case 'http://bigi-stg.sport5tv.co.il': // old link http://bigi-stg.sport5tv.co.il/
  //     //     url = 'http://bigi-stg.sport5tv.co.il/bigi_stg.json';
  //     //     break;

  //     // case 'https://35.186.202.81': // Staging
  //     // case 'https://bigi-stg.sport5tv.co.il':
  //     //     url = 'https://54.244.95.154/Bentley/Config/Kids_stg_rge.json';
  //     //     break;

  //     default:
  //         url = 'https://www.bigizone.co.il/bigi_prod.json';

  //         // url = 'http://dev-5now.lampawork.com/config/bigi/bigi_prod_config.json';
  //         break;
  // }

  // return {
  //     url
  // };
}

/**
 * Converts asset types from read data to application asset types.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Asset types.
 */
function convertAssetTypesFromRead(response = {}) {
  let assetTypes = {};

  assetTypes[AssetTypes.MOVIE] = response.Movie || 549;
  assetTypes[AssetTypes.EPISODE] = response.Episode || 550;
  assetTypes[AssetTypes.LINEAR] = response.Linear || 570;
  assetTypes[AssetTypes.SERIES] = response.Series || 551;
  assetTypes[AssetTypes.TEAM] = response.Team || 572;
  assetTypes[AssetTypes.SPORT] = response.Sport || 573;
  assetTypes[AssetTypes.LEAGUE] = response.League || 574;
  assetTypes[AssetTypes.EPG_ITEM] = response.program || 0;

  return assetTypes;
}

/**
 * Converts asset types from read data to application asset types.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Player params.
 */
function convertPlayerParamsFromRead(response = {}) {
  return {
    playerUrl:
      response.PlayerUrl ||
      "http://player.stg-ott.kaltura.com" +
        "/mwEmbed" +
        "/436" +
        "/v2.58.rc3_0_Bentley_web_v1.0" +
        "/mwEmbed" +
        "/mwEmbedLoader.php",
    apiUser: response.ApiUser || "tvpapi_433",
    apiPassword: response.ApiPass || "11111",
    uiConfId: response.uiConfId || 8413351,
    linearMediaFile: response.MediaFileLinear || "Web_Main3",
    vodMediaFile: response.MediaFileVOD || "Web_Main",
  };
}

/**
 * Converts read data to application data.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Converted read data.
 */
export function convertFromRead(response = {}) {
  return {
    baseUrl:
      response.Gateways ||
      "https://rest-eus1.ott.kaltura.com/restful/api_v3/service/",
    apiVersion: response.ApiVersion || "3.6.2075.27974",
    partnerId: response.GID || 436,
    rootCategory: response.RootCategoryID || 2742,
    discoverCategoryID: response.DiscoverCategoryID || 2811,
    catchupCategoryID: response.CatchupCategoryID || 2812,
    gtm: response.GTM || "GTM-K96RRLH",
    playerParams: convertPlayerParamsFromRead.call(this, response),
    assetTypes: convertAssetTypesFromRead.call(this, response),
    subscriptionId: response.SubscriptionId || 21106,
    responsysURL:
      response.responsysURL ||
      "https://bigi-default-dot-rge-ott.ey.r.appspot.com/server/datagate.php?type=addlead",
    onNowRetry: response.OnNowRetry || 5,
    onNowSecInterval: response.OnNowSecInterval || 15,
    landingPageConfigUrl:
      response.LandingPageConfigUrl || "http://localhost/lp_config.json", // TODO: change to default BE location
    autoStopStreamTimeout: response.time_to_sleep || 120,
    autoStopStreamDialogTimeout: response.time_to_sleep_msg || 10,
    switchToLive: response.SwitchToLive || 0,
    removeLoaderAfter: response.RemoveLoaderAfter || 8,
    paymentTmp: response.PaymentTmp,
    successPageVideo: response.SuccessPageVideoUrl || "",
  };
}



// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/config.js